import { Modals, Consts } from '../dependencies';

import CreateTag from '../components/CreateTag';

const { withModal } = Modals.HOC;

export default withModal(Consts.modals.CREATE_TAG)(CreateTag);
